// @ts-ignore
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GROWINTEL_PATHS } from '../constants/GrowintelPaths';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 py-16 text-center">
      <div className="mb-8">
        <h1 className="text-9xl font-extrabold text-gray-700 dark:text-gray-300">
          404
        </h1>
      </div>

      <h2 className="mb-4 text-2xl font-semibold text-gray-800 dark:text-white">
        Page Not Found
      </h2>

      <p className="mb-8 text-gray-600 dark:text-gray-400 max-w-md">
        The page you are looking for doesn't exist or has been moved. Please
        check the URL or navigate back to the homepage.
      </p>

      <div className="flex space-x-4">
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700"
        >
          Go Back
        </button>

        <Link
          to={GROWINTEL_PATHS.TRENDS}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-800"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
